import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    paddingTop: 5,
    paddingBottom: 5,
    marginBottom: 16,
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

const OrderViewInformationSectionTitle = ({
  children, className, classes,
}) => (
  <Typography
    className={classNames(className, classes.root)}
    color="secondary"
  >
    {children}
  </Typography>
);

OrderViewInformationSectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

OrderViewInformationSectionTitle.defaultProps = {
  className: '',
};

export default withStyles(styles)(OrderViewInformationSectionTitle);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationSectionTitle.js